import React from "react";
import { RestrictedByCapabilityAndDocumentPermissionByTypeWithDebug } from "../../auth/RestrictedByCapabilityAndDocumentPermissionByType.js";
import type { DocumentByType } from "../../auth/RestrictedByDocumentPermissionByType.js";
import { AskIfConditionExpressionIconField } from "../doc-items/fields/AskIfConditionExpressionField.js";

export function AskIfConditionCell({
  name,
  projectId,
  docId,
  itemId,
  propertyKey,
  document,
  disabled,
}: {
  name: string;
  projectId: string | null;
  docId: string;
  itemId: string;
  propertyKey: string;
  document: DocumentByType;
  disabled?: boolean;
}) {
  const field = (readOnly?: boolean) => (
    <AskIfConditionExpressionIconField
      name={name}
      projectId={projectId}
      docId={docId}
      itemId={itemId}
      currentItemId={itemId}
      currentPropertyKey={propertyKey}
      disabled={readOnly ? true : disabled}
      readOnly={readOnly}
    />
  );

  return (
    <RestrictedByCapabilityAndDocumentPermissionByTypeWithDebug
      capability="expressions"
      permissionByType={{
        QUOTE: "quote_expressions_update",
        REQUIREMENT: "requirement_expressions_update",
        TEMPLATE: "template_expressions_update",
        BUILDING: "building_expressions_update",
      }}
      document={document}
      otherwise={field(true)}
    >
      {field()}
    </RestrictedByCapabilityAndDocumentPermissionByTypeWithDebug>
  );
}
